// extracted by mini-css-extract-plugin
export default {"headerContainer":"OverviewHeader_headerContainer__q3yak","headerTitle":"OverviewHeader_headerTitle__jA3is"};